import { Model } from '@dimjs/model-react';
import { FabricExceptionModel } from './model.exception.js';
import { FabricFabricLoading } from './model.loading.js';

export const models = Model({
  FabricExceptionModel,
  FabricFabricLoading,
});
